import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../components/sidebar";
import { BASE_URL } from "../../utils/config";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TelegramWidget from "../../components/widget/telegramWidget";
import Loading from '../../components/loading'


const Userlist = () => {

  const navigate = useNavigate();
  const [loginuser, setLoginuser] = useState({});
  const [userLists, setUserLists] = useState([]);
  const [userList, setUserList] = useState([]);
  const [deleteUserDialog, setDeleteUserDialog] = useState(false);
  const [edituserDialog, setEdituserDialog] = useState(false);
  const [filters, setFilters] = useState();
  const [filteredUserLists, setfilteredUserLists] = useState();
  const [messageDialog,setMessageDialog]=useState(false)
  const [errorMessage,setErrorMessage]=useState('')
  const [isSuccess,setIsSuccess]=useState(false)
  const [isFailed,setIsFailed]=useState(false)
  const [ApiError,setApiError]=useState(false)
  const dt = useRef(null);
  const toast = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading,setLoading]=useState(true);
  const columns = [
    { id: "S.No", label: "S.No", minWidth: 70, align: "center" },
    { id: "user_name", label: "User Name", minWidth: 250, align: "center" },
    {
      id: "email_address",
      label: "Email ID",
      minWidth: 250,
      align: "center",
    },
    {
      id: "phone_number",
      label: "Phone No",
      minWidth: 170,
      align: "center",
    },
    {
      id: "logged_in",
      label: "Logged IN",
      minWidth: 70,
      align: "center",
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 170,
      align: "center",
    },
  ];


  useEffect(() => {
    fetchuserdata();
  }, []);

  //  this function is used to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //  this function is used to change rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };



  //  this function is used to fetch user list from DB
  const fetchuserdata = async () => {
    try{
    console.log("Fetching user list");
    let loginuser = JSON.parse(localStorage.getItem("loginData"));

    await fetch(`${BASE_URL}/getallusers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${loginuser.token}`
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if(res.success === true){
          setUserLists(res.usersData);
          setfilteredUserLists(res.usersData);
          let loginuser = JSON.parse(localStorage.getItem("userdetails"));
          setLoginuser(loginuser);
          setLoading(false);
        }else if(res.status === 403){ 
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setTimeout(() => {
          setMessageDialog(false); 
          setApiError(false);
          setErrorMessage('')
          localStorage.clear()
             navigate('/login')
        }, 3000);
        }
        else if(res.status === 401){
          
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setTimeout(() => {
          setMessageDialog(false); 
          setApiError(false);
          setErrorMessage('')
          localStorage.clear()
             navigate('/login')
        }, 3000);
        }else{
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setTimeout(() => {
          setMessageDialog(false); 
          setApiError(false);
          setErrorMessage('')
        }, 1700);
        }
       
      }).catch((error)=>{
        setErrorMessage(`Error: ${error.message}`)
        setApiError(true);
        setMessageDialog(true);
        setTimeout(() => {
          setMessageDialog(false); 
          setApiError(false);
        setErrorMessage('')
        }, 2000);
        
      })
    }catch(error){
      setErrorMessage(`Error: ${error.message}`)
      setApiError(true);
      setMessageDialog(true);
      setTimeout(() => {
        setMessageDialog(false); 
        setApiError(false);
      setErrorMessage('')
      }, 2000);
      
    }
  };

  //  this function is used to show button on right side
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
        <Stack direction="row" spacing={2}>
          <Link to="/usercreateForm">
            <Button variant="contained" startIcon={<AddIcon />}>
              Add User
            </Button>
          </Link>
          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}
          >
            Export
          </Button>
        </Stack>
      </div>
    );
  };

  //  this function is used to show button on left side
  const leftToolbarTemplate = () => {
    return (
      <>
        <span className="p-input-icon-left table-search">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={filters}
            onChange={handleSearch}
            placeholder="Search..."
          />
        </span>
      </>
    );
  };

  //  this function is used to handle search
  const handleSearch = (event) => {
    let filetertext = event.target.value;
    setFilters(event.target.value);
    setPage(0);
    setfilteredUserLists(userLists.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === 'string' &&
          value.toLowerCase().includes(filetertext.toLowerCase())
      )))
  };

  //  this function is used to export the excel sheet
  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(userLists);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "User_List");
    });
  };

  //  this function is used to save excel file
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        const date = new Date();

        // Extract date components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Extract time components
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");

        // Combine date and time components
        const dateTime = `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;

        module.default.saveAs(
          data,
          fileName + "_export_" + dateTime + EXCEL_EXTENSION
        );
      }
    });
  };

  //  this function is used to close delete popup
  const hideDeleteDialog = () => {
    setDeleteUserDialog(false);
  };

  // this is used to open delete user popup
  const confirmDeleteUser = (userlist) => {
    setUserList(userlist);
    setDeleteUserDialog(true);
  };

  //  this function is used to render 
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="actions">
        <i
          className="pi pi-user-edit"
          style={{ color: "#8a8a5c", cursor: "pointer", marginRight:"10px" }}
          title="Edit"
          onClick={() => confirmEdituser(rowData)}
        ></i>
       
        {rowData.logged_in === 1 ? (
          <i
            className="pi pi-trash "
            style={{ color: "#ff4d4d", cursor: "not-allowed" }}
            title="Not Allowed"
          ></i>
        ) : (
          <i
            className="pi pi-trash"
            style={{ color: "#ff4d4d", cursor: "pointer" }}
            title="Delete"
            onClick={() => confirmDeleteUser(rowData)}
          ></i>
        )}
      </div>
    );
  };

  //  this function is used to render login type based on condition
  const loginType = (rowData) =>{
    return (
        rowData.logged_in === 1 ? 'YES':'NO'
    );
  }

  // this function is used to delete user
  const deleteUser = async () => {
    try{
    let user_id = userList.user_id;
    let body = JSON.stringify({ modified_by:user_id });
    let loginData = JSON.parse(localStorage.getItem("loginData"));
    await fetch(`${BASE_URL}/softdeluser/${user_id}`, {
      method: "PUT",
      body,
      headers: {
        "Content-Type": "application/json",
         'Authorization': `Bearer ${loginData.token}`
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res.success === true) {
          let _products = userLists.filter(
            (val) => val.user_id !== userList.user_id
          );
          setUserLists(_products);
          setfilteredUserLists(_products);
          setDeleteUserDialog(false);
          setUserList("");
          setIsSuccess(true);
          setMessageDialog(true);

          setTimeout(() => {
            setMessageDialog(false); 
            setIsSuccess(false);
          
          }, 1700);
        }else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        } else {

          setIsFailed(true);
          setMessageDialog(true);

          setTimeout(() => {
            setMessageDialog(false); 
            setIsFailed(false);
          
          }, 1700);
          
        }
      }).catch((error)=>{
        setIsSuccess(false);
        setMessageDialog(true);
        setIsFailed(true);
        setMessageDialog(true);

        setTimeout(() => {
          setMessageDialog(false); 
          setIsFailed(false);
        
        }, 1700);
      })
    }catch(error){
      setErrorMessage(`Error: ${error.message}`)
      setApiError(true);
      setMessageDialog(true);
      setTimeout(() => {
        setMessageDialog(false); 
        setApiError(false);
        setErrorMessage('')
      
      }, 2000);
    }
  };

  //  this function is used to confirm popup
  const hideEditUserDialog = () => {
    setEdituserDialog(false);
  };

  // this function is used to redirect to user edit page
  const edituser = async () => {
    let userdetails = userList;
    console.log("userdetails===============: ", userdetails)
    navigate("/editprofile", {
      state: { userdetials: userdetails, edittype: "user" },
    });
  };

  //  this function is used to open a edit user popup
  const confirmEdituser = async (userlist) => {
    setUserList(userlist);
    setEdituserDialog(true);
  };


  return (
    <div>
      <Sidebar />
      {loading?
      <div style={{position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 2,}}>
        <Loading/>
      </div>
      :
      <div className="add-user user-list">
        <div className="container">
          <h2>User List</h2>
          <Toast ref={toast} position="top-center" />
          <Toolbar
            className="table-pre-head"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>
          <div className="table">
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead style={{backgroundColor:'#98C2EC'}}>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {filteredUserLists.length > 0?(
                  <TableBody>
                    {filteredUserLists
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.email_address}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.id === "S.No"
                                    ? index + 1
                                    : column.id === "user_name"
                                    ? `${row.first_name} ${
                                        row.middle_name || ""
                                      } ${row.last_name}`
                                    :column.id  ==="logged_in"
                                    ? loginType(row)
                                    :column.id === "Action"
                                    ? actionBodyTemplate(row)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                   ):null}
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUserLists.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
          <TelegramWidget/>

{/* delete user dialog for confirmation */}
          <Dialog
            open={deleteUserDialog}
            onClose={hideDeleteDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Delete"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {userList && (
                  <span style={{ color: "black" }}>
                    Are you sure, you want to Delete{" "}
                    <b>{userList.email_address}</b>?
                  </span>
                )}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideDeleteDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={deleteUser}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
{/* Edit user dialog */}
          <Dialog
            open={edituserDialog}
            onClose={hideEditUserDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Edit"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {userList && (
                  <span style={{ color: "black" }}>
                    Are you sure, you want to edit user {" "}
                    <b>{userList.email_address}</b>?
                  </span>
                )}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideEditUserDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={edituser}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

{/*  delete user success or failiure message */}
          <Dialog
      open={messageDialog}
      onClose={()=>{setMessageDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      
       {isSuccess?<h4 style={{ color: "green"}}>Success</h4>:null}
       {isFailed?<h4 style={{ color: "red" }}>Failure</h4>:null}
       {/* {ApiError ?<h4 style={{ color: "red" }}>Failure</h4>:null} */}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
            
              {isSuccess ? 
               <span style={{ color: "black" }}>
                  User Successfully Deleted.
                </span>
               : null}
                {isFailed?
                <span style={{ color: "black" }}>
                  Failed To Delete User.
                </span>:null}

                {ApiError?
                <span style={{ color: "black" }}>
                   {errorMessage}
                </span>:null}

                
              
           
        
        </DialogContentText>
      </DialogContent>
     
    </Dialog>
        </div>
      </div>
}
    </div>
  );
};

export default Userlist;
